module.exports = __webpack_public_path__ + "static/img/chair_jz_max.73c83e77.png";